import React from 'react'

import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled'

export const SyncPendingIcon = props => (
  <PauseCircleFilledIcon fontSize="small" {...props} />
)

export default SyncPendingIcon
